import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto p-4" }
const _hoisted_2 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-sm text-gray-600" }
const _hoisted_5 = { class: "text-lg font-semibold" }
const _hoisted_6 = { class: "text-sm text-gray-600" }

import { ref } from 'vue';

interface UpdateEntry {
  date: string;
  title: string;
  description: string;
  imageUrl: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'updates-view',
  setup(__props) {

const updates = ref<UpdateEntry[]>([
  {
    date: '25-08-2024',
    title: 'LIVE SET @ ELECTRO HAVEN',
    description: 'A 2-hour electrifying live set at Electro Haven, bringing fresh beats to an epic crowd!',
    imageUrl: 'https://example.com/electrohaven.jpg',
  },
  {
    date: '10-07-2024',
    title: 'SUMMER BEATS MIX VOL. 5',
    description: 'The latest installment of the Summer Beats series is here. Perfect for sunny vibes and good times.',
    imageUrl: 'https://example.com/summerbeats.jpg',
  },
  {
    date: '14-02-2024',
    title: 'BEHIND THE SCENES: TOURING IN EUROPE',
    description: 'A deep dive into the challenges and excitement of my 2024 European tour, from sold-out shows to new collaborations.',
    imageUrl: 'https://example.com/eurotour.jpg',
  },
  {
    date: '02-11-2023',
    title: 'STUDIO SESSIONS: NEW ALBUM TEASER',
    description: 'Get a sneak peek at my upcoming album with exclusive behind-the-scenes studio sessions.',
    imageUrl: 'https://example.com/studiosession.jpg',
  },
]);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-3xl font-bold mb-8 text-center" }, "UPDATES", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(updates.value, (update, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "space-y-2"
        }, [
          _createElementVNode("img", {
            src: update.imageUrl,
            alt: "update image",
            class: "w-full h-56 object-cover"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(update.date), 1),
          _createElementVNode("h3", _hoisted_5, _toDisplayString(update.title), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(update.description), 1),
          _cache[0] || (_cache[0] = _createElementVNode("a", {
            href: "#",
            class: "text-sm text-blue-600 font-semibold hover:underline"
          }, "READ MORE", -1))
        ]))
      }), 128))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("button", { class: "mt-8 px-4 py-2 border border-gray-400 hover:border-gray-600 transition-colors text-sm mx-auto block" }, " SHOW ALL ", -1))
  ]))
}
}

})